

import { Box, Button, Link, MenuItem, Paper, Popover, TextField, useMediaQuery } from "@mui/material";
import { BoxFC, BoxFR } from "components/BoxCustom";
import React, { useCallback, useContext, useEffect, useMemo, useState } from "react";
import ShippingJobDialog from "./ShippingJobDialog";
import { shippingProcessExportColumns } from "branch/constant/shipping/shippingColumnsExport";
import { shippingProcessImportColumns } from "branch/constant/shipping/shippingColumnsImport";
import DataGridCellExpand from "components/DataGridCellExpand/DataGridCellExpand";
import { GlobalStateContext } from "contexts/GlobalStateContext";
import { shippingApiNm } from "./shippingApiNm";
import { addIdForDataGrid } from "utils";
import { clearImportFilterData, initImportFilterData } from "branch/constant/shipping/initData";
import SearchButton from "components/buttons/SearchButton";
import ClearButton from "components/buttons/ClearButton";
import { shippingInvoiceColNm } from "./constant";
// import ShippingInvoiceDialog from "./ShippingInvoiceDialog";
import DateTimeSelect from "components/DateTimeSelect/DateTimeSelect";
import { UserContext } from "contexts/UserContext";
import UpdateTextDialog from "./UpdateTextDialog";
import { blue, blueGrey, cyan, deepPurple, green, lightGreen, red, teal, yellow } from "@mui/material/colors";
import dayjs from "dayjs";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { AddCircleRounded, ArticleRounded, FilterListRounded, LinkRounded } from "resource/muiImport";
import PopoverBarebone from "components/PopoverBarebone";
import ComboBox from "components/ComboBox";
import AddShippingInvoiceDialog from "./AddShippingInvoiceDialog";
// import ShipmentDialog from "pages/Menu1/ShipmentManagement/ShipmentDialog";
import { shipmentApiNm } from "constants/shipmentConstant";
import { groupJobOrderByContSizeFull } from "./ShippingInvoiceImportDialog";
import UpdatePOIDialog from "pages/Menu1/DailyJob/UpdatePOIDialog";
import { jobOrderApiNm, jobOrderColNm } from "constants/jobOrderConstant";
import { alertError } from "components/Alert";
import ShippingAllExpenseDialog from "./ShippingAllExpenseDialog";
import { GRID_CHECKBOX_SELECTION_COL_DEF } from "@mui/x-data-grid";
// import { printShippingProcess } from "./printShippingProcess";
import { printShippingExpense } from "./printShippingExpense";
import ShippingInvoiceDialogV2 from "./ShippingInvoiceDialogV2";
import SummaryBar from "pages/Menu1/DailyJob/SummaryBar";
import { initSummaryFilter } from "constants/dailyJobConstant";
import { shippingColNm } from "./constantLIT";
import { printShippingProcess } from "branch/constant/shipping/printShippingProcess";

const displayModule = {
  selection: false,
  sumRow: false,
  shpmType: false,
  trailerType: false,
  customer: true,
  job: false,
}

let lastFilter = null
let selectedId = null
let selectedColNm = ""
let oldTextData = ""
let filePopoverArr = []
let localAccountCombo = []
let oldTakePOIId = null
let selectedJobOrdIds = []
let selectedRow = null

let isChildExp = false
const ShippingProcessImport = ({ mode = 'IM' }) => {
  const { ax, msData } = useContext(GlobalStateContext)
  const { user } = useContext(UserContext)

  const readOnlyUser = useMemo(() => user.AccTypId !== 1, [user])

  const { queryParam, queryValue } = useParams()

  const [dialogShippingJobOpen, setDialogShippingJobOpen] = useState(false)
  const [dialogShippingInvoicegOpen, setDialogShippingInvoicegOpen] = useState(false)
  const [dialogUpdateTextOpen, setDialogUpdateTextOpen] = useState(false)
  const [dialogAddShippingProcessOpen, setDialogAddShippingProcessOpen] = useState(false)
  const [dialogPOIOpen, setDialogPOIOpen] = useState(false)
  const [dialogShippingAllExpense, setDialogShippingAllExpenseOpen] = useState(false)
  const [dataTable, setDataTable] = useState([])
  const [oneYearVsslData, setOneYearVsslData] = useState([])
  const [selectionmodel, setSelectionModel] = useState([])
  const [summaryFilter, setSummaryFilter] = useState(initSummaryFilter)
  // const [oneYearPortData, setOneYearPortData] = useState([])
  // const [anchorElEdit, setAnchorElEdit] = useState(null)
  const [filterData, setFilterData] = useState({ ...initImportFilterData })

  const [anchorEl, setAnchorEl] = useState(null);

  const w800 = useMediaQuery('(min-width:800px)');

  const popOverOpen = Boolean(anchorEl);

  const subcontractFilterMemo = useMemo(() => {
    const result = [
      { label: "ไม่จ้าง Shipping", id: -1, group: "สถานะจ้าง" },
      { label: "จ้าง Shipping", id: -2, group: "สถานะจ้าง" },
      ...msData.subContractCombo
    ]
    return result
  }, [msData.subContractCombo])

  const setAllData = useCallback((data) => {
    for (const row of data) {
      if (row.EDCfs) {
        const edCfs = JSON.parse(row.EDCfs)
        let lastIsCf = null
        let runTm = dayjs(0)
        let numRj = 0
        for (const edCf of edCfs) {
          edCf.CreTm = dayjs(edCf.CreTm)
          if (edCf.IsCf === 0) {
            numRj++
          }
          if (edCf.CreTm.isAfter(runTm)) {
            runTm = edCf.CreTm
            lastIsCf = edCf.IsCf
          }
        }
        row.EDCfs = edCfs
        row.LastIsCf = lastIsCf
        row.NumRj = numRj
      }
      const groupedArray = groupJobOrderByContSizeFull(row.JobOrders)
      row.Vol = groupedArray.map(item => `${item.count}x${item.text}`).join(", ")
    }
    setDataTable(addIdForDataGrid(data, "ShpInvId"))
  }, [])
  const getData = useCallback((filter) => {
    filter.ShpmTypId = mode === "IM" ? 2 : 1
    if(filter.FilterText){
      if(filter.FilterTextValue === null){
        alertError("กรุณาระบุคำค้นหา")
        return
      }
      filter.ContNo = null
      filter.JobNo = null
      filter.Bkg = null
      filter.IP_InvNo = null
      filter[filter.FilterText] = filter.FilterTextValue
    }
    ax.post(shippingApiNm.getShippingInvoice, filter).then(value => {
      if (value.data) {
        setAllData(value.data)
        lastFilter = { ...filter }
      }
    })
  }, [ax, setAllData, mode])

  const filterProps = useCallback((name) => ({
    size: "small",
    label: shippingInvoiceColNm[name],
    value: filterData[name] || "",
    sx: { width: 120 },
    onChange: (e) => setFilterData(o => ({ ...o, [name]: e.target.value || null })),
    onKeyUp: e => { if (e.code === "Enter" || e.code === "NumpadEnter") { getData(filterData) } },
  }), [filterData, getData])

  const filterPropsMobile = useCallback((name) => ({
    ...filterProps(name),
    sx: { width: "100%" },
  }), [filterProps])

  const dateTimeFilterProps = useCallback((label, filterSt, filterEn) => {
    return {
      sx: { width: 160 },
      label: label,
      start: filterData[filterSt],
      end: filterData[filterEn],
      setSelectDate: (start, end) => setFilterData(o => ({ ...o, [filterSt]: start, [filterEn]: end })),
      getData: () => getData(filterData)
    }
  }, [filterData, getData])

  const handleSearchButtonClick = useCallback(() => {
    getData(filterData)
  }, [getData, filterData])

  const handleClearFilterData = useCallback(() => {
    setFilterData({ ...clearImportFilterData })
  }, [])

  // const handleAddShippingProcess = useCallback(() => {
  //   //TODO:: add dialog add shipping process
  // }, [])

  const handleOpenShippingJob = useCallback(() => {
    setDialogShippingJobOpen(true)
  }, [])

  const onFinish = useCallback((data) => {
    if (data) {
      setAllData(data)
    } else {
      getData({ ...lastFilter })
    }
  }, [getData, setAllData])


  const handleFileClick = useCallback((shpInvId, values, field, row) => (e) => {
    console.log("values::", values)
    if (field === "JobOrderFiles") {
      console.log("JobOrderFiles::", values)
      if (values.length === 1) {
        window.open(values[0].Url)
      } else {
        filePopoverArr = values.map(file => ({
          url: file.Url,
          label: `${file.Label} (${file.ContNo})`
        }))
        setAnchorEl(e.currentTarget)
      }
    } else if (field === "ShFileNms"){
      if (values.length === 1) {
        window.open(`${window.location.origin}/file/shipment/${row.ShpmId}/${values[0].fileNm}`)
      } else {
        filePopoverArr = values.map(file => ({
          url: `${window.location.origin}/file/shipment/${row.ShpmId}/${file.fileNm}`,
          label: file.label
        }))
        setAnchorEl(e.currentTarget)
      }
    } else {
      if (values.length === 1) {
        window.open(`${window.location.origin}/file/shipping/${shpInvId}/${values[0].fileNm}`)
      } else {
        filePopoverArr = values.map(file => ({
          url: `${window.location.origin}/file/shipping/${shpInvId}/${file.fileNm}`,
          label: file.label
        }))
        setAnchorEl(e.currentTarget)
      }
    }
  }, [])

  const handlePopoverClose = useCallback(() => {
    setAnchorEl(null);
  }, [])

  const handleCellEdit = useCallback(({ id, field, value }) => {
    const shpmCols = ["JobNo", "Bkg", "Agnt", "ETA", "ETD", "Port"]
    let modValue = value
    if (field.endsWith("Tm")) {
      console.log("value::", value)
      if (value) {
        modValue = dayjs(value).format("YYYY-MM-DD HH:mm:ss")
      } else {
        modValue = null
      }
    } else if (field.endsWith("Dte")) {
      if (value) {
        modValue = dayjs(value).format("YYYY-MM-DD")
      } else {
        modValue = null
      }
    } else if (["ETA", "ETD"].includes(field)) {
      if (value) {
        modValue = dayjs(value).format("YYYY-MM-DD")
      } else {
        modValue = null
      }
    }

    const selectedIds = selectionmodel.includes(id) ? selectionmodel : [id]
    if (shpmCols.includes(field)) {

      const filtered = dataTable.filter(row => selectedIds.includes(row.id))
      if (filtered.length > 0) {

        const postData = {
          ColValues: {
            [field]: modValue,
          },
          ShpmIds: filtered.map(row => row.ShpmId),
        }
        ax.post(shippingApiNm.updateShipmentColumns, postData).then(value => {
          if (value.data) {
            setDataTable(o => {
              return o.map(row => {
                const found = filtered.find(f => f.id === row.id)
                if (found) {
                  return { ...row, [field]: modValue }
                }
                return row
              })
            })
          }
        })
      }
    } else {
      const postData = {
        ColValues: {
          [field]: modValue,
        },
        ShpInvIds: selectedIds,
        getArgs: lastFilter
      }
      console.log("handleCellEdit::", { postData })
      ax.post(shippingApiNm.updateShippingInvoiceColumns, postData).then(value => {
        if (value.data) {
          setAllData(value.data)
        }
      })
    }
  }, [ax, dataTable, setAllData, selectionmodel])

  const handleCellClick = useCallback(({ id, field, value, row }) => {
    selectedRow = row
    if (field === "ShowDetail") {
      selectedId = id
      setDialogShippingInvoicegOpen(true)
    } else if (field === "ShowDetailExpense") {
      isChildExp = false
      selectedId = id
      setDialogShippingAllExpenseOpen(true)
    } else if (field === "ShowDetailExpenseChild") {
      isChildExp = true
      selectedId = id
      setDialogShippingAllExpenseOpen(true)
    } else if (["Note", "Rmk", "EDNo", "Cnsg", "PO", "InvNo"].includes(field)) {
      selectedId = id
      selectedColNm = field
      oldTextData = value
      setDialogUpdateTextOpen(true)
    } else if (field === "TakePlc") {
      selectedJobOrdIds = row.JobOrders.map(jo => jo.JobOrdId)
      oldTakePOIId = row.TakePOIId
      if (selectedJobOrdIds.length === 0) {
        alertError("ไม่พบ Job Order ในใบแจ้งลากนี้")
        return
      }
      setDialogPOIOpen(true)
    }
  }, [])


  const handleLinkShippingProcess = useCallback(() => {
    setDialogAddShippingProcessOpen(true)
  }, [])

  const handleAddShippingProcess = useCallback(() => {
    if (oneYearVsslData.length === 0) {
      ax.post(shipmentApiNm.getOneYearVssl).then(value => {
        if (value.data) {
          setOneYearVsslData(value.data.Vssls)
          // setOneYearPortData(value.data.Ports)
          selectedId = null
          setDialogShippingInvoicegOpen(true)
        }
      })
    } else {
      selectedId = null
      setDialogShippingInvoicegOpen(true)
    }
  }, [oneYearVsslData, ax])

  const handleGetCellClassName = useCallback((params) => {
    const { field, row, value } = params;

    if (mode === "IM") {
      // If both BLRecvTm and BLCfTm are null, return empty class
      if (!row.BLRecvTm && !row.BLCfTm) {
        return "";
      }
      // Define the column order from BLRecvTm to CstmClrTm
      const progressColumns = [
        'BLRecvTm', 'BLCfTm', 'BLSndTm', 'ANRecvTm', 'MBLRecvTm', 'MBLEntrTm',
        'FrtInvTm', 'FrtInvPaidTm', 'DOMailTm', 'DORecvTm', 'CstmFormDfTm',
        'CstmFormCfTm', 'CstmClrTm', "FormTm", "Doc1Tm", "Doc2Tm", "DocSndTm",
        "EDCreTm", "EDSndTm", "EDCfTm", "ED0209CreTm", "ED0209SndTm",
        "ED0309CreTm", "ED0309SndTm", "ED0409CreTm", "ED0409SndTm",
        "CDCreTm", "CDAprvTm", "CDSndTm", "PayCstmTm",
      ];


      // Find the current field index
      const currentFieldIndex = progressColumns.indexOf(field);

      // If field is not in our progress columns, return empty
      if (currentFieldIndex === -1) {
        return "";
      }


      // Find the furthest column that has a value
      let furthestColumnWithValue = -1;
      if (row.BLRecvTm) {
        for (let i = progressColumns.length - 1; i >= 0; i--) { // Start from CstmClrTm (index 28), go back to BLCfTm (index 17)
          const columnField = progressColumns[i];
          if (row[columnField]) {
            furthestColumnWithValue = i;
            break;
          }
        }
      }

      if (furthestColumnWithValue !== -1 && currentFieldIndex <= furthestColumnWithValue) {
        return "green-progress";
      }


      return "";
    } else {
      // Define the column order from BLRecvTm to CstmClrTm
      const progressColumns = [
        "BLRecvTm", "FormTm", "Doc1Tm", "Doc2Tm", "DocSndTm",
        "EDCreTm", "EDSndTm", "EDCfTm", "ED0209CreTm", "ED0209SndTm",
        "ED0309CreTm", "ED0309SndTm", "ED0409CreTm", "ED0409SndTm",
        "CDCreTm", "CDAprvTm", "CDSndTm", "PayCstmTm", 'FrtInvTm',
      ];
      if (progressColumns.includes(field)) {
        return value ? "green-progress" : "";
      }
    }
  }, [mode])

  const handlePrintDriver = useCallback((row) => {
    printShippingProcess({ msData, shpData: row })

    // const shData = {
    //   ...row
    // }
    // printShippingProcess({ shData: shData, msData, jobOrdId: row.JobOrders[0]?.JobOrdId || 0 })
  }, [msData])

  const handleUpdateTime = useCallback(({ field, id }) => {

    const selectedIds = selectionmodel.includes(id) ? selectionmodel : [id]
    const postData = {
      ColValues: {
        [field]: dayjs().format("YYYY-MM-DD HH:mm:00"),
      },
      ShpInvIds: selectedIds,
      getArgs: lastFilter
    }
    console.log("handleCellEdit::", { postData })
    ax.post(shippingApiNm.updateShippingInvoiceColumns, postData).then(value => {
      if (value.data) {
        setAllData(value.data)
      }
    })
  }, [ax, setAllData, selectionmodel])

  const handleDeleteTime = useCallback(({ field, id }) => {
    const selectedIds = selectionmodel.includes(id) ? selectionmodel : [id]
    const postData = {
      ColValues: {
        [field]: null,
      },
      ShpInvIds: selectedIds,
      getArgs: lastFilter
    }
    console.log("handleCellEdit::", { postData })
    ax.post(shippingApiNm.updateShippingInvoiceColumns, postData).then(value => {
      if (value.data) {
        setAllData(value.data)
      }
    })
  }, [ax, setAllData, selectionmodel])

  const handleFileUploadSuccess = useCallback((uploadResponse) => {
    console.log("File uploaded successfully:", uploadResponse);
    getData({ ...lastFilter })
  }, [getData])

  const handlePrintExpense = useCallback((row) => {
    printShippingExpense({ msData, shpData: row })
  }, [msData])

  const handleUpdateETA = useCallback(({ id, row }) => () => {
    console.log("handleUpdateETA::", { id, row })
    const selectedIds = selectionmodel.includes(id) ? selectionmodel : [id]
    const postData = {
      ColValues: {
        IsCfETA: row.IsCfETA === 1 ? 0 : 1,
      },
      ShpInvIds: selectedIds,
      getArgs: lastFilter
    }
    console.log("handleCellEdit::", { postData })
    ax.post(shippingApiNm.updateShippingInvoiceColumns, postData).then(value => {
      if (value.data) {
        setAllData(value.data)
      }
    })
  }, [ax, setAllData, selectionmodel])

  const dataTableFiltered = useMemo(() => {
    return summaryFilter.CusIds.length === 0 ? dataTable
      : dataTable.filter(row => summaryFilter.CusIds.includes(row.CusId))
  }, [dataTable, summaryFilter])
  const shippingProcessColumnsMemo = useMemo(() => {
    return mode === "IM" ?
      shippingProcessImportColumns({
        handleFileClick,
        handlePrintDriver,
        handleUpdateTime,
        handleDeleteTime,
        onFileUploadSuccess: handleFileUploadSuccess,
        handlePrintExpense,
        handleUpdateETA
      })
      :
      shippingProcessExportColumns({
        handleFileClick,
        handlePrintDriver,
        handleUpdateTime,
        handleDeleteTime,
        onFileUploadSuccess: handleFileUploadSuccess,
        handlePrintExpense,
        handleUpdateETA
      })
  }, [mode, handleFileClick, handlePrintDriver, handleUpdateTime, handleDeleteTime, handleFileUploadSuccess
    , handlePrintExpense, handleUpdateETA])


  const updateJobOrderColumn = useCallback(async (colName, data, jobOrdIds, withFamily) => {
    const jsondata = {
      JobOrdIds: jobOrdIds,
      ColValues: data,
      WithFamily: withFamily,
      LogRmk: `แก้ไขข้อมูล ${jobOrderColNm[colName] || colName}`
    }
    await ax.post(jobOrderApiNm.updateJobOrderColumn, jsondata)
    getData(lastFilter);

  }, [ax, getData])

  useEffect(() => {
    const filter = { ...initImportFilterData }
    if (queryParam && queryValue) {
      filter[queryParam] = queryValue
      setFilterData(filter)
    }
    getData(filter)
  }, [getData, queryParam, queryValue])

  // useEffect(() => {
  //   const localMsData = JSON.parse(localStorage.getItem("msData"))
  //   console.log("localMsData::", localMsData)
  //   ax.post(shippingApiNm.getShippingAccount, {}).then(value => {
  //     if (value.data) {
  //       shippingAccounts = value.data.shippingAccounts
  //       localAccountCombo = value.data.localAccounts?.map(acc => ({ id: acc.AccId, label: `${acc.FName} ${acc.LName}(${acc.NName})` })) || []
  //     }
  //   })

  //   ax.post(shippingApiNm.getShippingJob, {}).then(value => {
  //     if (value.data) {
  //       const sjIds = value.data.map(sj => sj.JobId)
  //       const cusIds = localMsData.jobs.filter(job => sjIds.includes(job.JobId)).map(job => job.CusId)
  //       setCusShippingCombo(localMsData.cusCombo.filter(cus => cusIds.includes(cus.id)))
  //     } else {
  //       setCusShippingCombo(localMsData.cusCombo)
  //     }
  //   })
  // }, [ax])

  console.log("dataTable::", dataTable)
  return (
    <BoxFC height="100%">
      {w800 ? (
        <BoxFC>
          <BoxFR>
            <Box flex={1} />
            {/* <CheckboxFormControl label="ใช้รถ EEC" checked={filterData.IsOwnTuk === 1}
              onChange={(e) => setFilterData(o => ({ ...o, IsOwnTuk: e.target.checked ? 1 : 0 }))} /> */}

            {/* <TextField {...filterProps("Sts")} label="สถานะ" select>
              <MenuItem value={null}>ไม่ระบุ</MenuItem>
              <MenuItem value="NotFin">ยังไม่จบ</MenuItem>
              <MenuItem value="Fin">จบแล้ว</MenuItem>
            </TextField> */}
            <TextField {...filterProps("IsOwnTuk")} label={shippingInvoiceColNm.IsOwnTuk} select
              value={filterData.IsOwnTuk ?? ""}
              onChange={(e) => setFilterData(o => ({ ...o, IsOwnTuk: e.target.value }))}  >
              <MenuItem value={null}>ไม่ระบุ</MenuItem>
              <MenuItem value={1}>{shippingInvoiceColNm.IsOwnTuk}</MenuItem>
              <MenuItem value={0}>ไม่{shippingInvoiceColNm.IsOwnTuk}</MenuItem>
            </TextField>
            <TextField {...filterProps("ScSts")} label="สถานะแจ้งรถ" select
              value={filterData.ScSts ?? ""}
              onChange={(e) => setFilterData(o => ({ ...o, ScSts: e.target.value }))}>
              <MenuItem value={null}>ไม่ระบุ</MenuItem>
              <MenuItem value={0}>ยังไม่แจ้งรถ</MenuItem>
              <MenuItem value={1}>แจ้งรถแล้ว</MenuItem>
              <MenuItem value={2}>ยังไม่มีรูปตู้</MenuItem>
              <MenuItem value={3}>มีรูปตู้แล้ว</MenuItem>
              <MenuItem value={4}>ยังไม่ได้เบอร์ตู้</MenuItem>
              <MenuItem value={5}>ยังไม่ถึง รง.</MenuItem>
            </TextField>
            <TextField {...filterProps("ShpSts")} label="สถานะ Shipping" select>
              <MenuItem value={null}>ไม่ระบุ</MenuItem>
              <MenuItem value="NotFin">งานยังไม่จบ</MenuItem>
              <MenuItem value="BLRecvTm">รับ B/L</MenuItem>
              <MenuItem value="MBLEntrTm">Enter MB/L</MenuItem>
              <MenuItem value="FrtInvTm">Inv สายเรือ</MenuItem>
              <MenuItem value="DORecvTm">รับ DO</MenuItem>
              <MenuItem value="CstmFormDfTm">Draft ใบขน</MenuItem>
              <MenuItem value="CstmClrTm">พร้อมตรวจปล่อย</MenuItem>
            </TextField>
            <DateTimeSelect {...dateTimeFilterProps("วันที่นัดเข้า รง.", "AptTmSt", "AptTmEn")} />
            <DateTimeSelect {...dateTimeFilterProps(shippingInvoiceColNm.CstmClrTm, "CstmClrTmSt", "CstmClrTmEn")} />
            {/* <DateTimeSelect {...dateTimeFilterProps("วันที่รับ PL", "PLCreTmSt", "PLCreTmEn")} />
              <DateTimeSelect {...dateTimeFilterProps("วันที่ Draf ใบขน", "EDCreTmSt", "EDCreTmEn")} /> */}

            {/* <TextField {...filterProps("OwnAccNm")} /> */}
            {/* <TextField {...filterProps("ContNo")} />
            <TextField {...filterProps("JobNo")} />
            <TextField {...filterProps("Bkg")} />
            <TextField {...filterProps("IP_InvNo")} /> */}
            <ComboBox sx={{ width: 130 }} options={msData.accountCombo} label="ผู้รับผิดชอบงาน"
              selectedId={filterData.ManAccId}
              setSelectedId={(id) => setFilterData(o => ({ ...o, ManAccId: id }))}
            />
            <ComboBox sx={{ width: 150 }} options={msData.cusCombo} label="ลูกค้า"
              selectedId={filterData.CusId}
              setSelectedId={(id) => setFilterData(o => ({ ...o, CusId: id }))}
            />
            <ComboBox sx={{ width: 130 }} options={subcontractFilterMemo} label="จ้าง Shipping"
              selectedId={filterData.ScId}
              setSelectedId={(id) => setFilterData(o => ({ ...o, ScId: id }))}
            />
            <TextField {...filterProps("FilterText")} select label="ค้นหาหมายเลข">
              <MenuItem value={""}>ไม่ระบุ</MenuItem>
              <MenuItem value="JobNo">{jobOrderColNm.JobNo}</MenuItem>
              <MenuItem value="ContNo">{jobOrderColNm.ContNo}</MenuItem>
              <MenuItem value="Bkg">{jobOrderColNm.Bkg}</MenuItem>
              <MenuItem value="IP_InvNo">{shippingColNm.IP_InvNo}</MenuItem>
            </TextField>
            <TextField {...filterProps("FilterTextValue")} label="ค่าที่ค้นหา" />
            <SearchButton onClick={handleSearchButtonClick} />
            <ClearButton onClick={handleClearFilterData} />
          </BoxFR>
          {!readOnlyUser &&
            <BoxFR>
              {/* <AddButton onClick={handleAddShippingProcess}>เพิ่ม Invoice</AddButton> */}
              <BoxFR width={1250}>
                <Button variant="contained" onClick={handleAddShippingProcess}><AddCircleRounded sx={{ mr: 1 }} /> เพิ่มใบแจ้งลาก</Button>
                <Button variant="contained" onClick={handleLinkShippingProcess}><LinkRounded sx={{ mr: 1 }} /> ผูกใบแจ้งลาก</Button>
                <Button variant="contained" onClick={handleOpenShippingJob}><ArticleRounded sx={{ mr: 1 }} /> งาน-Shipping </Button>
                {/* <Button variant="contained" onClick={() => { setDialogCCEDMailConfirm(true) }}><EmailRounded sx={{ mr: 1 }} />กำหนด Email ผู้รับยืนยันใบขน</Button> */}

              </BoxFR>
              <SummaryBar
                dataTable={dataTable}
                summaryFilter={summaryFilter}
                setSummaryFilter={setSummaryFilter}
                selectionModel={[]}
                displayModule={displayModule} />
            </BoxFR>
          }

        </BoxFC>

      ) : (
        <PopoverBarebone
          transformOrigin={{ vertical: "top", horizontal: "left" }}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          component={<Button variant="contained" sx={{ width: 150 }}>
            <FilterListRounded sx={{ mr: 1 }} /> FILTER
          </Button>}
        >
          <Paper sx={{ p: 2, width: 230 }}>
            <BoxFC sx={{ gap: 1 }}>
              {!readOnlyUser &&
                <BoxFR>
                  <Button variant="contained" onClick={handleOpenShippingJob}><ArticleRounded sx={{ mr: 1 }} /> งาน-Shipping </Button>
                  {/* <Button variant="contained" onClick={() => { setDialogCCEDMailConfirm(true) }}><EmailRounded sx={{ mr: 1 }} />กำหนด Email ผู้รับยืนยันใบขน</Button> */}
                </BoxFR>
              }
              <Box flex={1} />

              <DateTimeSelect {...dateTimeFilterProps("วันที่นัดเข้า รง.", "AptTmSt", "AptTmEn")} />
              <TextField {...filterPropsMobile("OwnAccNm")} />
              <TextField {...filterPropsMobile("Bkg")} />
              <TextField {...filterPropsMobile("IP_InvNo")} />
              <SearchButton onClick={handleSearchButtonClick} />
              <ClearButton onClick={handleClearFilterData} />
            </BoxFC>
          </Paper>
        </PopoverBarebone>
      )}

      <Box width='100%' mt={w800 ? 2 : 0} flexGrow={1} sx={{
        '& .pl-col': { backgroundColor: deepPurple[100] },
        '& .ed-col': { backgroundColor: cyan[50] },
        '& .ed0209-col': { backgroundColor: teal[100] },
        '& .ed0309-col': { backgroundColor: lightGreen[100] },
        '& .ed0409-col': { backgroundColor: green[100] },
        '& .cd-col': { backgroundColor: blue[100] },
        '& .ed-cf-reject': { backgroundColor: red[100] },
        '& .green-progress': { backgroundColor: green[50] },
        '& .yellow-progress': { backgroundColor: yellow[50] },
        '& .MuiDataGrid-row:hover': {
          backgroundColor: blueGrey[50],
          '& .normal-col': { backgroundColor: blueGrey[50] },
          '& .pl-col': { backgroundColor: deepPurple[200] },
          '& .ed-col': { backgroundColor: cyan[100] },
          '& .ed0209-col': { backgroundColor: teal[200] },
          '& .ed0309-col': { backgroundColor: lightGreen[200] },
          '& .ed0409-col': { backgroundColor: green[200] },
          '& .ed-cf-reject': { backgroundColor: red[200] },
          '& .cd-col': { backgroundColor: blue[200] },
          '& .green-progress': { backgroundColor: green[100] },
          '& .yellow-progress': { backgroundColor: yellow[100] },
        },
        '& .Mui-selected': {
          backgroundColor: blueGrey[50],
          '& .pl-col': { backgroundColor: deepPurple[200] },
          '& .ed-col': { backgroundColor: cyan[100] },
          '& .ed0209-col': { backgroundColor: teal[200] },
          '& .ed0309-col': { backgroundColor: lightGreen[200] },
          '& .ed0409-col': { backgroundColor: green[200] },
          '& .ed-cf-reject': { backgroundColor: red[200] },
          '& .cd-col': { backgroundColor: blue[200] },
          '& .green-progress': { backgroundColor: green[100] },
          '& .yellow-progress': { backgroundColor: yellow[100] }
        },
      }}>
        <DataGridCellExpand
          checkboxSelection
          selectionmodel={selectionmodel}
          onSelectionModelChange={(ids) => { setSelectionModel(ids) }}
          hideFooter
          rows={dataTableFiltered}
          columns={shippingProcessColumnsMemo}
          onCellEditCommit={handleCellEdit}
          // onRowDoubleClick={!readOnlyUser ? handleRowDoubleClick : null}
          onCellClick={!readOnlyUser ? handleCellClick : null}
          initialState={{
            pinnedColumns:
            {
              left: [GRID_CHECKBOX_SELECTION_COL_DEF.field, 'ShowDetail', 'ShowDetailExpense'
                , 'ShowDetailExpenseChild', 'gotoJobOrder', 'No', 'JobNo', "ManAccNNmCS"
                , "ManAccNNm", "RecvDocDte", "CusSNm", mode === "IM" ? "ETA" : null]
            }
          }}
          columnVisibilityModel={{
            ShowDetail: !readOnlyUser,
            EDAprvTm: !readOnlyUser,
            CDAprvTm: !readOnlyUser,
            Note: !readOnlyUser,
          }}
          getCellClassName={handleGetCellClassName} />

      </Box>
      <Popover
        open={popOverOpen}
        anchorEl={anchorEl}
        onClose={handlePopoverClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center', }}
        transformOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Paper sx={{ p: 1 }}>
          <BoxFC sx={{ gap: 1 }}>
            {
              filePopoverArr.map((file, index) => (
                <Link href={file.url} target="_blank" key={index}>
                  <Button variant="outlined" size="small">{file.label}</Button>
                </Link>
              ))
            }
          </BoxFC>
        </Paper>
      </Popover>
      <ShippingJobDialog
        dialogOpen={dialogShippingJobOpen}
        setDialogOpen={setDialogShippingJobOpen}
        onFinish={onFinish} />
      {/* <PackingListDialog
        selectedId={selectedId}
        selectedJobId={selectedJobId}
        dialogOpen={dialogPLOpen}
        cusId={selectedCusId}
        setDialogOpen={setDialogPLOpen}
        onFinish={onFinish}
        lastFilter={lastFilter}
        shippingAccounts={shippingAccounts} /> */}
      {/* <ShippingInvoiceDialog
        selectedId={selectedId}
        dialogOpen={dialogShippingImportOpen}
        setDialogOpen={setDialogShippingImportOpen}
        onFinish={onFinish}
        lastFilter={lastFilter}
        localAccountCombo={localAccountCombo} /> */}
      {/* <AddFileWithSendDialog
        shpmFileTypId={shpFileTypId}
        title={dialogTitle}
        colNm={selectedColNm}
        selectedId={selectedId}
        dialogOpen={dialogAddFileWithSendOpen}
        setDialogOpen={setDialogAddFileWithSendOpen}
        onFinish={onFinish}
        lastFilter={lastFilter} /> */}
      {/* <ED0209Dialog
        selectedId={selectedId}
        dialogOpen={dialogED0209Open}
        setDialogOpen={setDialogED0209Open}
        onFinish={onFinish}
        lastFilter={lastFilter} /> */}
      <UpdateTextDialog
        selectedId={selectedId}
        oldData={oldTextData}
        colNm={selectedColNm}
        dialogOpen={dialogUpdateTextOpen}
        setDialogOpen={setDialogUpdateTextOpen}
        onFinish={onFinish}
        lastFilter={lastFilter} />
      {/* <ApproveDialog
        selectedId={selectedId}
        dialogOpen={dialogApproveOpen}
        setDialogOpen={setDialogApproveOpen}
        onFinish={onFinish}
        lastFilter={lastFilter} />
      <ApproveCDDialog
        selectedId={selectedId}
        dialogOpen={dialogCDApproveOpen}
        setDialogOpen={setDialogCDApproveOpen}
        onFinish={onFinish}
        lastFilter={lastFilter} />
      <RejectDetailDialog
        selectedId={selectedId}
        dialogOpen={dialogRejectDetailOpen}
        setDialogOpen={setDialogRejectDetailOpen} />
      <ReceiveEDMallConfirmDialog
        dialogOpen={dialogCCEDMailConfirm}
        setDialogOpen={setDialogCCEDMailConfirm} /> */}
      <AddShippingInvoiceDialog
        dialogOpen={dialogAddShippingProcessOpen}
        setDialogOpen={setDialogAddShippingProcessOpen}
        onFinish={onFinish}
        lastFilter={lastFilter} />
      {/* <SendEmailDialog
        shpInvId={selectedId}
        dialogOpen={dialogSendEmailOpen}
        setDialogOpen={setDialogSendEmailOpen}
        colNm={selectedColNm}
        onFinish={onFinish} /> */}
      {/* <ShipmentDialog
        state={shipmentDialogStateMemo}
        fn={shipmentDialogFnMemo} /> */}
      <ShippingInvoiceDialogV2
        selectedId={selectedId}
        dialogOpen={dialogShippingInvoicegOpen}
        setDialogOpen={setDialogShippingInvoicegOpen}
        onFinish={onFinish}
        lastFilter={lastFilter}
        localAccountCombo={localAccountCombo}
        mode={mode} />
      <UpdatePOIDialog
        dialogOpen={dialogPOIOpen}
        setDialogOpen={setDialogPOIOpen}
        colName="TakePOIId"
        oldData={oldTakePOIId}
        jobOrdIds={selectedJobOrdIds}
        updateColumn={updateJobOrderColumn}
        selectedRow={selectedRow} />
      <ShippingAllExpenseDialog
        isChildExp={isChildExp}
        selectedId={selectedId}
        dialogOpen={dialogShippingAllExpense}
        setDialogOpen={setDialogShippingAllExpenseOpen}
        onFinish={onFinish}
      />
    </BoxFC>
  )
}

export default ShippingProcessImport;